export default {
  getCustomerUser: (state) => state.customerUser,
};
